export * from './machine-pool-new-template';
